import { useLocalSearchParams, useRouter } from 'expo-router'

import { PublicationCommentPrayScreen } from '@/src/features/publication/ui/screens/PublicationCommentPrayScreen'

export type TPublicationRewardPraySearchParams = { commentAuthor: string; responseId?: number }
type TPublicationRewardPrayParams = { commentId: string; id: string }

const PublicationRewardPrayRouterPage = () => {
  const { commentAuthor, ...localSearchParams } = useLocalSearchParams<
    TSearchParams<TPublicationRewardPraySearchParams> & TPublicationRewardPrayParams
  >()
  const { back } = useRouter()
  const commentId = Number(localSearchParams.commentId)
  const publicationId = Number(localSearchParams.id)
  const responseId = Number(localSearchParams.responseId)

  if (!commentId || !publicationId || !commentAuthor) return back()

  return (
    <PublicationCommentPrayScreen
      commentAuthor={commentAuthor}
      commentId={commentId}
      publicationId={publicationId}
      responseId={responseId}
    />
  )
}

export default PublicationRewardPrayRouterPage
